import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useSnackbar } from 'notistack';

/**
 * 비밀번호 초기화로 발급된 임시 비밀번호를 "한 번만" 보여주는 다이얼로그.
 * 서버는 이 값을 응답에만 담아 돌려주고 저장하지 않는다 — 닫으면 다시 볼 수 없다(S01, 2026-10-16).
 */
const TempPasswordDialog = ({ visible, tempPassword, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(tempPassword || '');
      enqueueSnackbar('임시 비밀번호를 복사했습니다', { variant: 'success' });
    } catch (err) {
      enqueueSnackbar('복사에 실패했습니다. 직접 선택해 복사하세요.', {
        variant: 'error',
      });
    }
  };

  return (
    <Dialog
      open={visible}
      onClose={onClose}
      aria-labelledby="temp-password-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="temp-password-dialog-title">
        <Typography variant="subtitle2" component="div">
          임시 비밀번호 발급
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography
          sx={{ whiteSpace: 'pre-line', mb: 2 }}
          variant="body2"
          component="div"
        >
          {
            '아래 임시 비밀번호는 지금만 확인할 수 있습니다.\n해당 사원에게 안전한 방법(직접 전달, 사내 메신저 등)으로 전달하세요.\n이 사원의 다른 모든 로그인 세션은 종료되었습니다.'
          }
        </Typography>
        <TextField
          fullWidth
          value={tempPassword || ''}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleCopy} edge="end" aria-label="복사">
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-end' }}>
        <Button variant="contained" onClick={onClose} autoFocus>
          확인(닫기)
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TempPasswordDialog;
